module.exports = __webpack_public_path__ + "static/media/hall-P8.8d2ad863.svg";